export const categories = [
  {
    id: 'jiaoyou',
    name: '交友互动',
    slug: '交友互动',
    description: '找到志同道合的朋友，拓展社交圈，开启真诚交流',
    icon: 'ri-heart-line',
    color: 'primary',
    articleCount: 128,
  },
  {
    id: 'shenghuo',
    name: '生活资讯',
    slug: '生活资讯',
    description: '健康、旅行、美食、时尚等全方位生活指南',
    icon: 'ri-compass-3-line',
    color: 'accent',
    articleCount: 96,
  },
  {
    id: 'quanyi',
    name: '权益支持',
    slug: '权益支持',
    description: '法律咨询、权益科普、心理健康支持资源',
    icon: 'ri-shield-line',
    color: 'secondary',
    articleCount: 74,
  },
  {
    id: 'gushi',
    name: '真实故事',
    slug: '真实故事',
    description: '聆听社群成员的真实经历与成长故事',
    icon: 'ri-book-open-line',
    color: 'primary',
    articleCount: 156,
  },
  {
    id: 'huodong',
    name: '活动资讯',
    slug: '活动资讯',
    description: '线上线下活动信息、骄傲月、社群聚会',
    icon: 'ri-calendar-event-line',
    color: 'accent',
    articleCount: 63,
  },
  {
    id: 'jiankang',
    name: '健康专栏',
    slug: '健康专栏',
    description: '身心健康知识、防艾科普、医疗资源指南',
    icon: 'ri-heart-pulse-line',
    color: 'secondary',
    articleCount: 89,
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '出柜后，我找到了真正的自己',
    category: '真实故事',
    categorySlug: 'gushi',
    summary: '从小在传统家庭长大的小陈，花了十年时间才鼓起勇气向父母出柜。如今回望这段旅程，他感慨万千。',
    content: `## 序章：十年的沉默

我叫小陈，今年32岁，来自一个普通的中国家庭。从初中开始，我就隐约察觉到自己和其他男生有些不同——当同学们讨论班上哪个女生好看时，我却总是忍不住偷看隔壁班的体育委员。

那种感觉既陌生又恐惧。在2000年代初的中国小城市，同性恋这个词几乎等同于禁忌。我在沉默中度过了整个青春期，把真实的自己深深地藏了起来。

## 大学时代：第一次恋爱

大二那年，我在学校BBS上认识了他。我们用私信聊了一个多月，从电影聊到音乐，从理想聊到人生。第一次见面是在学校后门的奶茶店，紧张得手心全是汗。

那是一段美好的初恋，也让我第一次确认了自己是谁。但两个人都害怕被同学发现，约会总是在很远的街区，牵手也只敢在深夜无人的操场上。

毕业后，因为家庭和工作的压力，我们分手了。

## 出柜：最艰难也最值得的决定

30岁那年的春节，我终于下定决心。我约父母坐在客厅，深呼吸了无数次，然后把准备了整整一年的信递给了他们。

母亲的眼泪、父亲的沉默，那是我人生中最漫长的十分钟。但让我意外的是，沉默了许久的父亲最终说了一句："不管怎样，你都是我的儿子。"

那一刻，我哭了。不是因为委屈，而是因为被接纳。

## 现在的我

如今，我在上海有一个稳定的伴侣，我们在一起两年了。周末我们会一起逛菜市场、做饭、看电影，过着和任何一对情侣一样的平淡生活。

我也加入了本地的LGBT社群组织，偶尔参加一些分享会，帮助那些还在迷茫中的人。

出柜不是终点，而是新生活的起点。我想对还在犹豫的朋友说：你不必急着向所有人坦白，但请记得，真实的自己值得被看见，也值得被爱。`,
    author: '小陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%20early%2030s%20with%20warm%20smile%2C%20casual%20outfit%2C%20portrait%20photography%20with%20soft%20natural%20light%2C%20simple%20neutral%20background%2C%20friendly%20and%20approachable%20expression&width=120&height=120&seq=author-xiaochen&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Warm%20sunset%20light%20streaming%20through%20window%20curtains%20in%20a%20cozy%20living%20room%2C%20two%20men%20sitting%20on%20sofa%20having%20a%20heartfelt%20conversation%2C%20emotional%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20orange%20and%20golden%20tones%2C%20soft%20focus%2C%20intimate%20documentary%20style%20photography&width=800&height=500&seq=article-gushi-1&orientation=landscape',
    date: '2026-08-10',
    readTime: 8,
    tags: ['出柜', '家庭', '自我认同'],
  },
  {
    id: 'article-2',
    title: '2026年国内LGBT友好城市生活指南',
    category: '生活资讯',
    categorySlug: 'shenghuo',
    summary: '我们走访了北京、上海、成都、深圳等城市，为你整理了一份最全面的男同友好城市生活指南。',
    content: `## 引言

随着社会包容度的不断提升，越来越多的城市开始展现出对LGBT群体的友好姿态。但每个城市的文化氛围、社群活跃度、生活成本各不相同。

本文基于对100多位社群成员的调研和实地走访，为大家呈现一份真实可靠的指南。

## 上海：国际化与包容并存

作为中国最国际化的城市，上海的男同社群非常活跃。从法租界的咖啡店到静安区的酒吧，这里有全国最丰富的线下社群场所。

- **社群活跃度**：★★★★★
- **生活成本**：较高（月均8000-12000元）
- **推荐区域**：静安区、徐汇区、长宁区
- **热门场所**：幸福里、永平里、Fuxing Park周边

## 成都：慢生活与高包容

成都以其悠闲的生活节奏和开放的社会氛围，成为很多男同选择的"第二故乡"。这里没有一线城市的快节奏压力，却有同样包容的环境。

- **社群活跃度**：★★★★☆
- **生活成本**：适中（月均5000-8000元）
- **推荐区域**：武侯区、锦江区、高新区
- **热门场所**：春熙路商圈、九眼桥、桐梓林

## 深圳：年轻与活力

作为一座年轻的移民城市，深圳对多元文化的包容度极高。这里的LGBT社群以年轻化、高学历为特点。

- **社群活跃度**：★★★★☆
- **生活成本**：较高（月均7000-11000元）
- **推荐区域**：南山区、福田区
- **热门场所**：华侨城创意园、海上世界、COCO Park

## 北京：文化底蕴深厚

北京拥有全国最早的LGBT公益组织和最丰富的文化活动。虽然城市节奏偏快，但社群的文化氛围非常浓厚。

- **社群活跃度**：★★★★★
- **生活成本**：较高（月均7000-10000元）
- **推荐区域**：朝阳区、海淀区
- **热门场所**：三里屯、鼓楼、望京

## 结语

无论你在哪个城市，找到属于自己的社群和安全空间是最重要的。希望这份指南能帮到你，也欢迎在评论区分享你所在城市的友好去处。`,
    author: '编辑部',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20modern%20Chinese%20man%20with%20glasses%2C%20editorial%20style%20portrait%2C%20warm%20neutral%20background%2C%20friendly%20professional%20look&width=120&height=120&seq=author-editor&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Aerial%20urban%20cityscape%20at%20sunset%20with%20colorful%20neon%20lights%20and%20modern%20skyscrapers%2C%20warm%20golden%20hour%20lighting%2C%20vibrant%20and%20inclusive%20city%20atmosphere%2C%20wide%20angle%20photography%2C%20soft%20atmospheric%20haze&width=800&height=500&seq=article-city-guide&orientation=landscape',
    date: '2026-08-08',
    readTime: 10,
    tags: ['城市生活', '指南', '社群'],
  },
  {
    id: 'article-3',
    title: '中国LGBT权益保护法律知识手册',
    category: '权益支持',
    categorySlug: 'quanyi',
    summary: '了解你的合法权益，学会在需要时保护自己。我们整理了与LGBT群体最相关的法律知识和维权途径。',
    content: `## 前言

在法律层面，虽然中国的LGBT权益保护仍在发展过程中，但《宪法》赋予每个公民平等的人格尊严和人身权利。了解相关法律知识，是保护自身权益的第一步。

## 一、人格权与隐私保护

根据《民法典》，每个人都享有人格权，包括姓名权、肖像权、名誉权、隐私权等。这意味着：

- 任何人不得强迫他人公开其性取向信息
- 未经本人同意公开他人性取向信息，可能构成隐私侵权
- 职场中因性取向遭受歧视，可通过劳动仲裁维权

## 二、反就业歧视

《就业促进法》规定，劳动者就业不因民族、种族、性别、宗教信仰等不同而受歧视。虽然性取向未在法条中明确列举，但"等"字为扩大解释提供了可能。

如果你在求职或工作中因性取向受到明显歧视，建议：
1. 保留相关证据（聊天记录、录音、邮件等）
2. 向劳动监察部门投诉
3. 必要时寻求法律援助

## 三、心理健康支持

根据《精神卫生法》，每个人都享有获得精神卫生服务的权利。如果你因为性取向相关问题感到困扰：

- 全国心理援助热线：400-161-9995
- 北京同志中心心理咨询热线：010-64031683
- 彩虹心理热线（每周五19:00-22:00）：400-699-1201

## 四、社群互助资源

除了法律援助，社群互助也是重要的支持网络：

- **北京同志中心**：成立于2008年，提供心理咨询、法律援助等服务
- **同性恋亲友会**：专注于家庭接纳与亲子关系修复
- **彩虹法律热线**：为LGBT群体提供免费法律咨询

## 结语

权益保护不是一朝一夕的事，但了解自己的合法权利，并学会在必要时寻求帮助，是每个人都应该做的功课。希望这篇文章能为你提供一些实用的指引。`,
    author: '法律顾问组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20legal%20advisor%20portrait%2C%20confident%20expression%2C%20warm%20and%20trustworthy%20look%2C%20simple%20studio%20background%2C%20soft%20lighting&width=120&height=120&seq=author-legal&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20legal%20books%20and%20documents%20on%20a%20warm%20wooden%20desk%2C%20soft%20sunlight%20from%20window%2C%20scales%20of%20justice%20statue%20in%20background%2C%20peaceful%20and%20dignified%20atmosphere%2C%20warm%20tones&width=800&height=500&seq=article-legal-rights&orientation=landscape',
    date: '2026-08-05',
    readTime: 12,
    tags: ['法律', '权益', '维权'],
  },
  {
    id: 'article-4',
    title: '三十岁后，我们的爱情更从容了',
    category: '真实故事',
    categorySlug: 'gushi',
    summary: '两个三十多岁的男同伴侣，分享他们在一起五年的相处之道和对未来的规划。',
    content: `## 相遇

我和阿杰认识的时候，我31岁，他33岁。都不再是二十出头那个为爱不顾一切的年纪了。

我们在一次朋友组织的桌游局上认识。他输了游戏接受惩罚时唱了一首《十年》，跑调得厉害，但笑得特别灿烂。那一刻我突然觉得，这个人的笑容很好看。

## 在一起

没有轰轰烈烈的表白，也没有纠结和拉扯。成年人的感情有时候就是这么简单——觉得合适，就在一起了。

我们的约会内容经常是周末一起去超市买菜，然后回家做饭。阿杰的番茄牛腩做得特别好，我负责洗碗。这种平淡的日常，反而让人觉得踏实。

## 关于未来

到了我们这个年纪，恋爱不只是风花雪月。我们讨论过很多现实问题：要不要买房、怎么告诉家里人、未来的养老规划。

去年我们用两个人的积蓄在成都买了一套小两居。虽然每个月还贷压力不小，但拿着钥匙走进属于自己的家的那一刻，觉得一切都值得。

## 想对年轻的朋友说

二十岁的时候，总觉得爱情应该是惊天动地的。但到了三十岁，你会发现，能在周末的早晨被一个人吻醒，然后一起去吃一碗热腾腾的面，已经是世界上最幸福的事了。`,
    author: '阿文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20mid%2030s%20with%20gentle%20smile%2C%20casual%20sweater%2C%20warm%20portrait%20photography%2C%20simple%20neutral%20background%2C%20kind%20eyes%2C%20soft%20natural%20lighting&width=120&height=120&seq=author-awen&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Two%20men%20cooking%20together%20in%20a%20warm%20cozy%20kitchen%20with%20sunlight%20streaming%20in%2C%20laughing%20and%20enjoying%20domestic%20life%2C%20modern%20apartment%20interior%2C%20warm%20and%20intimate%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=article-couple-home&orientation=landscape',
    date: '2026-08-03',
    readTime: 6,
    tags: ['伴侣', '生活', '未来规划'],
  },
  {
    id: 'article-5',
    title: '男同社群心理健康指南：如何建立自信与自我接纳',
    category: '健康专栏',
    categorySlug: 'jiankang',
    summary: '心理健康专家为你解答：如何面对社会偏见，建立自我认同，保持积极的心理状态。',
    content: `## 为什么这个话题很重要

根据多项研究，LGBT群体面临的心理健康挑战远高于一般人群。社会偏见、家庭压力、自我认同困惑等因素，都可能给心理健康带来影响。

但这不意味着我们必须被这些困难定义。通过正确的方法和支持，每个人都可以建立健康的自我认知。

## 第一步：认识并接纳自己的情感

很多人在意识到自己的性取向后，第一反应是否认和压抑。请记住：

- 你的感受是真实且有效的
- 性取向不是一种选择，而是你本真的一部分
- 感到困惑和不安是正常的，无需自责

## 第二步：建立支持网络

没有人是一座孤岛。以下方式可以帮助你建立支持：

1. **找到可信赖的朋友**：先和已经支持LGBT的朋友倾诉
2. **加入线上社群**：在安全的环境中与他人交流经验
3. **寻求专业帮助**：当情绪困扰影响到日常生活时，不要犹豫联系心理咨询师

## 第三步：培养日常心理健康习惯

- **正念练习**：每天花10分钟进行正念冥想
- **身体运动**：规律运动能显著改善情绪状态
- **记录感恩**：每天写下三件让你感恩的小事
- **设定边界**：学会对消耗你能量的人和事说"不"

## 第四步：关注身体健康

心理健康和身体健康密不可分：

- 定期进行性健康检查
- 了解PrEP和PEP等预防措施
- 保持规律的作息和均衡的饮食
- 如有需要，到正规医疗机构咨询激素治疗等选项

## 写给还在迷茫的你

这条路可能不容易，但你并不孤单。在这个世界的某个角落，有成千上万和你一样的人在努力生活、爱人、追求幸福。给自己多一点耐心和温柔，你值得拥有一个被爱、被尊重的人生。`,
    author: '心理顾问组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20psychologist%20with%20warm%20smile%2C%20modern%20office%20background%2C%20trustworthy%20and%20empathetic%20expression%2C%20soft%20portrait%20lighting&width=120&height=120&seq=author-psych&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20space%20with%20warm%20morning%20sunlight%2C%20indoor%20plants%2C%20comfortable%20cushion%20on%20wooden%20floor%2C%20calm%20and%20serene%20atmosphere%2C%20minimalist%20interior%2C%20soft%20golden%20light%2C%20wellness%20and%20mindfulness%20aesthetic&width=800&height=500&seq=article-mental-health&orientation=landscape',
    date: '2026-08-01',
    readTime: 7,
    tags: ['心理健康', '自我接纳', '自信'],
  },
  {
    id: 'article-6',
    title: '2026年夏季LGBT骄傲月活动指南',
    category: '活动资讯',
    categorySlug: 'huodong',
    summary: '各地骄傲月活动汇总，包括线上讨论、线下聚会、电影放映等丰富多彩的活动安排。',
    content: `## 前言

每年6月是全球骄傲月，虽然国内的活动形式与海外有所不同，但越来越多的城市在6月前后会有丰富的社群活动。本文为你整理了今年夏季值得关注的活动信息。

## 线上活动

### "彩虹对话"系列线上分享会
- **时间**：6月每周六下午3:00-5:00
- **平台**：腾讯会议
- **主题**：涵盖出柜经验、伴侣关系、职场融入等话题

### 骄傲月线上观影会
- **时间**：6月15日-30日
- **方式**：线上同步观看 + 映后讨论
- **片单**：《请以你的名字呼唤我》、《月光男孩》、《燃烧女子的肖像》等

## 线下活动（需提前报名）

### 北京骄傲跑
- **时间**：6月第三个周日
- **地点**：奥林匹克森林公园
- **报名方式**：通过社群公众号报名

### 上海彩虹市集
- **时间**：6月周末
- **地点**：静安区某创意园区
- **内容**：手工艺品、文创周边、社群义卖

### 成都社群户外徒步
- **时间**：6月每个周六
- **地点**：青城山/龙泉山轮换
- **报名方式**：成都彩虹户外群

## 国外值得关注的活动

如果你计划出境旅行：

- **台北骄傲游行**：亚洲最大的骄傲游行之一（10月）
- **曼谷骄傲节**：东南亚最盛大的LGBT庆典（6月）
- **东京彩虹骄傲**：日本最具规模的LGBT活动（4月）

## 温馨提示

参加任何活动前，请确认活动的合法性和安全性。选择有组织的、公开透明的活动，保护好自己的隐私和个人信息。`,
    author: '活动组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20energetic%20Chinese%20man%20with%20creative%20style%2C%20event%20planner%20portrait%2C%20colorful%20casual%20outfit%2C%20friendly%20and%20enthusiastic%20expression&width=120&height=120&seq=author-event&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20community%20gathering%20in%20a%20sunny%20park%2C%20diverse%20group%20of%20people%20enjoying%20outdoor%20activities%2C%20rainbow%20banners%20and%20decorations%2C%20joyful%20and%20celebratory%20atmosphere%2C%20warm%20summer%20light%2C%20inclusive%20community%20event%20photography&width=800&height=500&seq=article-pride-events&orientation=landscape',
    date: '2026-07-28',
    readTime: 6,
    tags: ['骄傲月', '活动', '社群'],
  },
  {
    id: 'article-7',
    title: '如何与父母沟通你的性取向：一份温柔指南',
    category: '交友互动',
    categorySlug: 'jiaoyou',
    summary: '出柜是一个需要勇气和智慧的决定。我们整理了一份温柔的沟通指南，帮助你更好地与父母交流。',
    content: `## 写在前面

向父母坦诚自己的性取向，是很多人人生中最重要也最艰难的决定之一。这份指南不会催促你做任何决定——什么时候准备好，完全由你自己决定。

## 出柜前先问自己几个问题

1. 我是否已经完成了自我接纳？
2. 我是否有经济独立的能力？
3. 我是否有支持系统（朋友、伴侣、社群）？
4. 我对父母可能的反应是否有心理准备？

如果以上有任何一个答案是"不确定"，不妨先给自己更多时间。

## 沟通策略

### 选择合适的时机和环境
- 选择父母情绪稳定、没有压力的时间
- 最好在家中进行，一个让人感到安全的空间
- 避免在节日、家庭聚会等场合

### 做好信息准备
- 提前了解一些科学的性取向知识
- 准备一些正面的LGBT社群资料
- 了解父母可能会有的疑问和担忧

### 沟通方式建议
1. **先铺垫**：可以说"有件重要的事想和你们聊聊"
2. **直接但温柔**：明确表达，但语气保持平和
3. **给他们时间**：父母可能需要时间消化，这很正常
4. **强调爱不变**：告诉父母，你的性取向不会改变你对他们的爱

## 常见父母反应及应对

- **否认**："你只是还没遇到对的人"→ 温柔而坚定地解释
- **自责**："是不是我们做错了什么"→ 安抚他们，这不是谁的错
- **愤怒**：给他们一些空间和时间
- **接纳**：感恩并珍惜这份理解

## 如果沟通不顺利

请记住：你有权利保护自己的心理健康。如果父母的反应过于激烈，给自己一些距离是合理的选择。同时，寻求社群支持和专业心理咨询可以帮助你度过这段艰难时期。

## 那些温暖的例子

"我跟妈妈说完后，她沉默了很久，然后说：'那你要照顾好自己，找个好人。'——这是我听到过最温暖的话。"

"我爸说：'我不太懂这些，但你是我儿子，永远都是。'"

希望有一天，这样的故事不再是个例，而是常态。`,
    author: '社群支持组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Compassionate%20Chinese%20community%20supporter%20portrait%2C%20gentle%20and%20understanding%20expression%2C%20warm%20lighting%2C%20simple%20background&width=120&height=120&seq=author-support&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Warm%20living%20room%20with%20soft%20afternoon%20sunlight%2C%20tea%20set%20on%20a%20wooden%20table%2C%20comfortable%20sofa%20with%20cushions%2C%20peaceful%20and%20safe%20atmosphere%20for%20heartfelt%20conversation%2C%20cozy%20home%20interior%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-family-talk&orientation=landscape',
    date: '2026-07-25',
    readTime: 9,
    tags: ['出柜', '家庭沟通', '父母'],
  },
  {
    id: 'article-8',
    title: '男同健康防护全攻略：从日常保健到定期筛查',
    category: '健康专栏',
    categorySlug: 'jiankang',
    summary: '全面的男同健康管理指南，包括性健康防护、定期体检项目、疫苗接种建议等。',
    content: `## 为什么男同群体需要特别的健康关注

每个人的健康需求都不完全相同。对于男同群体来说，了解与自己相关的健康风险并采取适当的预防措施，是自我关爱的重要部分。

## 性健康防护

### HIV预防
- **PrEP（暴露前预防）**：每日服用可大幅降低感染HIV的风险，有效率超过99%
- **PEP（暴露后预防）**：高风险暴露后72小时内服用，连续28天
- **安全套**：始终是最基础也最有效的保护措施之一
- **定期检测**：建议每3-6个月进行一次HIV检测

### 其他性传播感染
- 梅毒、淋病、衣原体等也需要定期筛查
- 大多数性传播感染是可以治愈的，关键在于早发现早治疗
- HPV疫苗接种建议（适用于26岁以下人群）

## 定期体检项目建议

### 基础项目（每年一次）
- 血常规、尿常规
- 肝肾功能
- 血脂血糖

### 针对性项目
- HIV抗体检测（每3-6个月）
- 梅毒血清学检测（每6个月）
- 乙肝、丙肝检测
- 肛门细胞学检查（建议每1-3年）

## 心理健康维护

- 定期自我心理状态评估
- 建立稳定的社交支持网络
- 必要时寻求专业心理咨询
- 学习压力管理和情绪调节技巧

## 生活方式建议

- **规律运动**：每周至少150分钟中等强度运动
- **均衡饮食**：多摄入蔬果、优质蛋白
- **充足睡眠**：每天7-8小时
- **戒烟限酒**：减少有害物质摄入
- **定期体检**：早发现、早干预

## 获取帮助的渠道

- 各地疾控中心提供免费HIV检测
- 社区组织提供匿名检测和咨询
- 三甲医院感染科/皮肤科提供专业的性健康服务

记住，关注自己的健康是对自己和伴侣最大的负责。`,
    author: '健康顾问组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20healthcare%20professional%20portrait%2C%20white%20coat%2C%20warm%20and%20professional%20demeanor%2C%20clean%20medical%20office%20background%2C%20trustworthy%20expression&width=120&height=120&seq=author-health&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20consultation%20room%20with%20warm%20lighting%2C%20stethoscope%20on%20desk%2C%20green%20plant%2C%20professional%20yet%20welcoming%20healthcare%20environment%2C%20soft%20natural%20light%2C%20calm%20and%20reassuring%20atmosphere&width=800&height=500&seq=article-health-guide&orientation=landscape',
    date: '2026-07-20',
    readTime: 8,
    tags: ['健康', '体检', '预防'],
  },
];